var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chartContainer"},[_c('p',[_vm._v("Tagesverlauf")]),_c('line-chart',{attrs:{"data":_vm.graphData(),"suffix":" W","points":false,"curve":false,"colors":['#ffffff'],"dataset":{color: 10},"library":_vm.library}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }